import React from 'react';

const formatCurrency = (value) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value || 0);

const Metric = ({ label, value, accent }) => (
  <div className="rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-4 py-3">
    <div className="text-xs text-[var(--fg-muted)]">{label}</div>
    <div className={`text-lg font-bold ${accent ? 'text-[var(--fg-accent)]' : 'text-[var(--fg-text)]'}`}>{value}</div>
  </div>
);

const FundingLenderPerformancePanel = ({ performance, loading }) => {
  if (loading) return <p className="text-sm text-[var(--fg-muted)]">Loading historical performance...</p>;
  if (!performance) return <p className="text-sm text-[var(--fg-muted)]">No historical performance yet.</p>;

  return (
    <div className="space-y-3">
      <p className="text-sm text-[var(--fg-muted)]">
        Historical performance across matches, submissions, deals, and projected commissions for this workspace.
      </p>
      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
        <Metric label="Matches" value={performance.matchCount ?? 0} />
        <Metric label="Submissions" value={performance.submissionCount ?? 0} />
        <Metric label="Pipeline deals" value={performance.dealCount ?? 0} />
        <Metric label="Funded deals" value={performance.fundedDealCount ?? 0} accent />
        <Metric label="Total funded amount" value={formatCurrency(performance.totalFundedAmount)} />
        <Metric label="Projected commissions" value={formatCurrency(performance.projectedCommissions)} />
        <Metric label="Earned commissions" value={formatCurrency(performance.earnedCommissions)} accent />
        <Metric label="Paid commissions" value={formatCurrency(performance.paidCommissions)} />
        <Metric label="Match to submission" value={`${performance.submittedVsMatchedConversion ?? 0}%`} />
      </div>
    </div>
  );
};

export default FundingLenderPerformancePanel;
